const property = {
  property: {
    breadcrumbProperty: 'Property',
    backToResults: 'Back to results',
    guestsCount: '{{count}} guests',
    loadingMessage: 'Loading property details...',
    errorTitle: 'Property not found',
    errorMessage: 'Could not load this property\'s details. Please check the link or try again.',
    availableUnits: '{{count}} unit{{suffix}} available',
    noAvailability: 'No availability',
    photoAlt: 'Photo {{index}}',
    aboutProperty: 'About the property',
    amenities: 'Amenities',
    accommodations: 'Accommodations',
    pricingForDates: 'Prices for {{nights}} {{nightLabel}} · {{checkIn}} → {{checkOut}}',
    selectDatesHint: 'Select dates in the search to see prices and availability.',
    available: 'Available',
    unavailable: 'Unavailable',
    upToGuests: 'Up to {{count}} guests',
    included: 'included',
    perNightTotal: '/ night · total',
    unavailableForDates: 'Unavailable for these dates',
    bookNow: 'Book now',
    noUnitsAvailable: 'No units available for the selected dates.',
    tryOtherDates: 'Try other dates',
    reviews: 'Reviews',
    verified: 'Verified',
    location: 'Location',
    viewOnMaps: 'View on Google Maps',
    contact: 'Contact',
    officialSite: 'Official website',
    whatsappContact: 'Chat on WhatsApp',
    pageTitle: '{{name}} - Reserve Connect',
    pageTitleFallback: 'Property - Reserve Connect',
    pageDescription: '{{description}} in {{city}}. Check availability and real prices.',
    pageDescriptionFallback: 'Property details on Reserve Connect.',

    // Cancellation policy display
    policyFlexible: 'Free Cancellation',
    policyFlexibleBadge: 'Free Cancellation',
    policyFlexibleDesc: 'Cancel up to 24 hours before check-in for a full refund.',
    policyModerate: 'Moderate',
    policyModerateBadge: 'Moderate',
    policyModerateDesc: 'Cancel up to 5 days before for a full refund. Up to 24 hours before, 50% refund.',
    policyStrict: 'Strict',
    policyStrictBadge: 'Strict',
    policyStrictDesc: 'Cancel up to 7 days before for a 50% refund. After that, no refund.',
    policyUnknown: 'Cancellation policy',
    policyUnknownDesc: 'Check the booking terms for cancellation details.',
    policyLearnMore: 'Learn more',
  },
};
export default property;
